export interface LanguageCatalogEntry {
  id: string;
  /** Native display name (what the row shows). */
  name: string;
  /** English name of the language. */
  nativeName: string;
  flag: string;
  /** Only enabled languages can be selected; the rest are "Coming soon". */
  enabled: boolean;
}

export const LANGUAGES: LanguageCatalogEntry[] = [
  { id: "en", name: "English", nativeName: "English", flag: "🇺🇸", enabled: true },
  { id: "es", name: "Español", nativeName: "Spanish", flag: "🇪🇸", enabled: false },
  { id: "hi", name: "हिन्दी", nativeName: "Hindi", flag: "🇮🇳", enabled: false },
  { id: "zh", name: "中文", nativeName: "Chinese", flag: "🇨🇳", enabled: false },
];

export const DEFAULT_SETTINGS = {
  autoLock: false,
  language: "en",
  sound: false,
  advancedViewQuotes: false,
  isAdvancedTradesVisible: true,
  newsEnabled: false,
  lockScreenStatus: "Disabled",
  columns: ["Ask", "Bid", "Day %"],
  oneClickTrading: false,
  agentTradingConsent: false,
  notifyOrderUpdate: true,
  notifyOrderProgress: false,
  dealDetailsExtended: false,
  mcpServerEnabled: false,
  mcpAutostart: true,
  mcpServerPort: 7717,
  mcpAllowTradingWrites: false,
};

export const QUOTE_COLUMNS = [
  "Ask",
  "Bid", 
  "Day %",
  "Bid High",
  "Bid Low",
  "Ask High",
  "Ask Low",
  "Last",
  "Last High",
  "Last Low",
  "Time",
  "Spread",
];
